import React, { useState } from 'react';

import { TabForm } from '../../../../common/components/Tabs';
import { FormSection, FormSubmitButton } from '../../../../common/components/Form/Form';
import { DateInput } from '../../../../common/components/Form/FormDateInput';
import { Notice, NoticeText } from '../../../../common/components/Notice';
import { hasBlockingFundingDocuments } from '../../../../common/components/Funders/documentCompletion';
import { FundingDocumentsReviewPanel } from './FundingDocumentsReviewPanel';

export const BlocCTab3 = ({ formik }) => {
  const [blocked, setBlocked] = useState(true);

  return (
    <TabForm onSubmit={formik.handleSubmit}>
      <FundingDocumentsReviewPanel
        folderId={formik.values.folderId}
        onChanged={documents => setBlocked(hasBlockingFundingDocuments(documents))}
      />
      <FormSection title="Réception des pièces">
        <DateInput
          label="Date de réception des documents"
          name="fundingDocumentsReceivedAt"
          id="fundingDocumentsReceivedAt"
          disabled={blocked}
        />

        <Notice variant="warning">
          <NoticeText variant="warning">
            Vérifier le Diagnostic socio-administratif et mettre les données à jour si nécessaire
          </NoticeText>
        </Notice>
      </FormSection>

      <FormSubmitButton type="submit" isLoading={formik.isSubmitting} loadingText="Enregistrer">
        Enregistrer
      </FormSubmitButton>
    </TabForm>
  );
};
